import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { type ModuleWithProviders, NgModule } from '@angular/core';

import type { AuthConfig } from './auth.models';
import { AuthRoutingModule } from './auth.routing';
import { AuthService } from './auth.service';
import { BECKS_AUTH_CONFIG } from './auth.tokens';
import { AuthHttpInterceptor } from './interceptors/auth.interceptor';

@NgModule({
  imports: [AuthRoutingModule, CommonModule],
})
export class AuthModule {
  static forRoot(config: AuthConfig): ModuleWithProviders<AuthModule> {
    return {
      ngModule: AuthModule,
      providers: [
        AuthService,
        { provide: BECKS_AUTH_CONFIG, useValue: config },
        { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
      ],
    };
  }
}
